module.exports = __webpack_public_path__ + "static/media/classme-new-white-logo.9cb19591.svg";